import { render, staticRenderFns } from "./bottomLeft1.vue?vue&type=template&id=390086c2&scoped=true&"
import script from "./bottomLeft1.vue?vue&type=script&lang=js&"
export * from "./bottomLeft1.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeft1.vue?vue&type=style&index=0&id=390086c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390086c2",
  null
  
)

export default component.exports